import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator } from "@/components/ui/command";
import { NAV_GROUPS } from "./nav-config";
import { demoAction } from "@/lib/demo";
import { Plus, Globe, Rocket, Archive } from "lucide-react";

const QUICK = [
  { label: "Novo Projeto", icon: Plus, action: (nav) => demoAction("Novo Projeto") },
  { label: "Adicionar Domínio", icon: Globe, action: (nav) => nav("/dominios") },
  { label: "Novo Deploy", icon: Rocket, action: (nav) => nav("/deployments") },
  { label: "Backup Agora", icon: Archive, action: (nav) => demoAction("Backup Agora") },
];

// Paleta de comandos global (Ctrl/Cmd + K).
export const CommandMenu = ({ open, setOpen }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if ((e.key === "k" && (e.metaKey || e.ctrlKey))) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [setOpen]);

  const go = (to) => {
    setOpen(false);
    navigate(to);
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Buscar páginas, ações, servidores..." data-testid="command-input" />
      <CommandList>
        <CommandEmpty>Nenhum resultado.</CommandEmpty>
        <CommandGroup heading="Ações rápidas">
          {QUICK.map((q) => (
            <CommandItem key={q.label} onSelect={() => { setOpen(false); q.action(navigate); }}>
              <q.icon className="mr-2 h-4 w-4 text-brand" />{q.label}
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandSeparator />
        {NAV_GROUPS.map((group) => (
          <CommandGroup key={group.label} heading={group.label}>
            {group.items.map((item) => (
              <CommandItem key={item.to} onSelect={() => go(item.to)}>
                <item.icon className="mr-2 h-4 w-4" />{item.label}
              </CommandItem>
            ))}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
};
